import { ILanguage } from "src/app/core/models/i-language";

export function languageNameByCode(
  languages: ILanguage[],
  code: string
): string {
  const language = languages.find((lang) => lang.Code === code);
  return language ? language.FriendlyName : 'none';
}
